import React, { useState } from "react";
import { connect } from "react-redux";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import MetaHead from "../../../Common/Metahead";
import { updateSetting } from "../../../../stores/actions/settings.actions.types";
import Delete from "../../../Modals/delete";
import SMSTemplateAddModal from "../../../Modals/add-sms-template";
import SMSTemplateEditModal from "../../../Modals/update-sms-template";

const SmsTemplatePage = ({ setting, updateSetting, reload, setReload }) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [updateLoading, setUpdateLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // UPDATE
  const handleUpdateSubmit = (values) => {
    setUpdateLoading(true);

    updateSetting({
      data: {
        ...setting,
        smsTemplates: setting.smsTemplates.map((item) =>
          item.key === selectedTemplate.key ? values : item,
        ),
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setEditModalOpen(false);
          setUpdateLoading(false);
        }
      },
    });
  };

  // ADD
  const handleAddSubmit = (values) => {
    setAddLoading(true);

    updateSetting({
      data: {
        ...setting,
        smsTemplates: [...setting.smsTemplates, values],
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setAddModalOpen(false);
          setAddLoading(false);
        }
      },
    });
  };

  // DELETE
  const handleDelete = () => {
    setDeleteLoading(true);

    updateSetting({
      data: {
        ...setting,
        smsTemplates: setting.smsTemplates.filter(
          (item) => item.key !== selectedTemplate.key,
        ),
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setDeleteModalOpen(false);
          setDeleteLoading(false);
        }
      },
    });
  };

  return (
    <div className='mx-auto p-6 bg-white shadow-lg rounded-2xl dark:bg-gray-800'>
      <MetaHead title='SMS Template Management' />

      <div className='flex justify-between items-center mb-6'>
        <h1 className='text-2xl font-bold'>SMS Templates</h1>
        <button
          onClick={() => setAddModalOpen(true)}
          className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1'
        >
          <FaPlus /> Add Template
        </button>
      </div>

      <div className='space-y-4'>
        {setting?.smsTemplates?.map((template, index) => (
          <div
            key={index}
            className='p-3 border border-gray-200 dark:border-gray-700 rounded-xl flex justify-between items-center'
          >
            <div>
              <p>
                <strong>Key:</strong> {template.key}
              </p>
              <p>
                <strong>Message:</strong> {template.message}
              </p>
            </div>

            <div className='flex gap-2'>
              <button
                onClick={() => {
                  setSelectedTemplate(template);
                  setEditModalOpen(true);
                }}
                className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1'
              >
                <FaEdit />
              </button>

              <button
                onClick={() => {
                  setSelectedTemplate(template);
                  setDeleteModalOpen(true);
                }}
                className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1'
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}
      </div>

      <SMSTemplateEditModal
        opened={editModalOpen}
        setOpened={setEditModalOpen}
        selectedTemplate={selectedTemplate}
        loading={updateLoading}
        handleSubmit={handleUpdateSubmit}
      />

      <SMSTemplateAddModal
        opened={addModalOpen}
        setOpened={setAddModalOpen}
        loading={addLoading}
        handleSubmit={handleAddSubmit}
      />

      {/* Delete Modal */}
      <Delete
        opened={deleteModalOpen}
        setOpend={setDeleteModalOpen}
        title='Delete SMS Template'
        handleDelete={handleDelete}
        loading={deleteLoading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  updateSetting,
})(SmsTemplatePage);
